// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { localize } from 'i18n-calypso'

class Footer extends React.Component {
	render() {
		const { translate, locale, hasMultipleLocales } = this.props
		const homeUrl = hasMultipleLocales ? `/${locale}/` : '/'

		const textBy = translate( 'Copyright &copy; %(currentYear)s %(site_name)s', {
			args: {
				currentYear: siteData.current_year,
				site_name: siteData.site_name
			}
		} )

		return (
			<footer className="footer">
				<div className="-logo">
					<a href={ homeUrl }>
						<img src={ siteData.images_url + 'logo/adventist_church_in_nzpuc_text_horizontal_charcoal.svg?v=2' } alt={ siteData.site_name } />
					</a>
				</div>

				<p>
					Level 1 Fencible House, 18 Fencible Drive, Howick, New Zealand
				</p>

				<p>
					<span dangerouslySetInnerHTML={ { __html: textBy } } />
					<br />
					{ translate( 'Website by' ) } <a href="http://alexgreendesign.com" target="_blank">Alex Green Design</a>
				</p>
			</footer>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		locale: state.site.locale,
		hasMultipleLocales: state.site.hasMultipleLocales
	}
}

export default localize(
	connect( mapStateToProps )( Footer )
)



// WEBPACK FOOTER //
// ./components/Footer/Footer.jsx